import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ICustoRecursoPlanejamentoModel } from '../models/custo-recurso-planejamento.model';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustoRecursoPlanejamentoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }



  public async obterPorId(id: number, tipoTrabalho: string, secaoId?: number): Promise<IBaseModel<ICustoRecursoPlanejamentoModel[]>> {
    if (tipoTrabalho === 'planejamento') {
      const url = `${this.apiBaseUrl}/custoRecursoPlanejamento/${id}`;

      const parametroSessao = secaoId != null ? `/secao/${secaoId}` : '';

      return this.httpClient
        .get<IBaseModel<ICustoRecursoPlanejamentoModel[]>>(url + parametroSessao)
        .toPromise();
    }
    if (tipoTrabalho === 'osa') {
      return this.httpClient
        .get<IBaseModel<ICustoRecursoPlanejamentoModel[]>>(`${this.apiBaseUrl}/custoRecursoOsa/osa/${id}`)
        .toPromise();
    }
  }

  public inserir(data: ICustoRecursoPlanejamentoModel, tipoTrabalho: string) : Observable<IBaseModel<ICustoRecursoPlanejamentoModel>> {
    if (tipoTrabalho === 'planejamento') {
      return this.httpClient.post<IBaseModel<ICustoRecursoPlanejamentoModel>>(`${this.apiBaseUrl}/custoRecursoPlanejamento`, data);
    }
    if (tipoTrabalho === 'osa') {
      return this.httpClient.post<IBaseModel<ICustoRecursoPlanejamentoModel>>(`${this.apiBaseUrl}/custoRecursoOsa`, data)
    }
  }

  public atualizar(data: ICustoRecursoPlanejamentoModel, tipoTrabalho: string) : Observable<IBaseModel<ICustoRecursoPlanejamentoModel>> {
    if (tipoTrabalho === 'planejamento') {
      return this.httpClient.put<IBaseModel<ICustoRecursoPlanejamentoModel>>(`${this.apiBaseUrl}/custoRecursoPlanejamento/${data.id}`, data)
    }
    if (tipoTrabalho === 'osa') {
      return this.httpClient.put<IBaseModel<ICustoRecursoPlanejamentoModel>>(`${this.apiBaseUrl}/custoRecursoOsa/${data.id}`, data)
    }
  }

  public excluir(id: number, tipoTrabalho: string): Observable<IBaseModel<void>> {
    if (tipoTrabalho === 'planejamento') {
      return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecursoPlanejamento/${id}`)
    }
    if (tipoTrabalho === 'osa') {
      return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecursoOsa/${id}`)
    }
  }
}